import React, { useState, useEffect } from "react";
import { Input } from "@chakra-ui/react";
import { AgendaModal } from "@components";
import { useUpdateSingleAgendaMutation } from "@store/api/agenda";

const RenameAgendaModal = ({ isOpen, onClose, agendaId, currentTitle }) => {
  const [newTitle, setNewTitle] = useState(currentTitle || "");
  const [updateAgenda, { isLoading }] = useUpdateSingleAgendaMutation();

  useEffect(() => {
    if (isOpen) {
      setNewTitle(currentTitle || "");
    }
  }, [isOpen, currentTitle]);

  const handleRename = async () => {
    const trimmedTitle = newTitle.trim();

    if (!trimmedTitle || trimmedTitle === currentTitle) {
      onClose();
      return;
    }

    try {
      await updateAgenda({
        agendaId,
        meetingData: { title: trimmedTitle },
      }).unwrap();
      onClose();
    } catch (error) {
      console.error("Failed to rename agenda:", error);
    }
  };

  const isValidTitle =
    newTitle.trim().length > 0 && newTitle.trim().length <= 200;

  return (
    <AgendaModal
      title="Rename Agenda"
      body={
        <Input
          placeholder="Enter new agenda title"
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
          maxLength={200}
          autoFocus
          onKeyPress={(e) => {
            if (e.key === "Enter" && isValidTitle) {
              handleRename();
            }
          }}
        />
      }
      isOpen={isOpen}
      isLoading={isLoading}
      onClose={onClose}
      handlePrimaryAction={handleRename}
      primaryButtonText="Rename"
      primaryButtonVariant={isValidTitle ? "primary" : "ghost"}
    />
  );
};

export default RenameAgendaModal;
